import {
  Cin7OmniBomImportStrategy,
  Cin7OmniSalesOrderStage,
} from "@redotech/redo-integrations-definitions-common/cin7-omni-integration";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const cin7OmniSettings = defineIntegrationSettings({
  fields: {
    apiUsername: z.string().trim(),
    omsEnabled: z.boolean(),
    bomImportStrategy: createEnum(Cin7OmniBomImportStrategy),
    beginningSyncableStage: createEnum(Cin7OmniSalesOrderStage),
    returnsEnabled: z.boolean(),
    baseUrl: z.string().trim().min(1).nullable(),
    createReturnsEnabled: z.boolean(),
    processReturnsEnabled: z.boolean(),
    returnTypeCustomFieldName: z.string().trim().min(1).nullable(),
    compensationMethodCustomFieldName: z.string().trim().min(1).nullable(),
    creditNoteCustomFields: z.array(
      z.object({
        fieldKey: z.string().trim().min(1, "Field name is required"),
        fieldValue: z.string().trim().min(1, "Field value is required"),
      }),
    ),
  },
  secrets: { apiKey: z.string().trim().min(1, "API key is required") },
  connectOnly: {},
  computed: {},
});
